import { Bell, Search, Moon, Sun } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getNotifications } from '../../lib/api';

export const Header = ({ title }) => {
    const [isDark, setIsDark] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        const isDarkMode = document.documentElement.classList.contains('dark');
        setIsDark(isDarkMode);
        
        fetchUnreadCount();
    }, []);

    const fetchUnreadCount = async () => {
        try {
            const response = await getNotifications({ is_read: false });
            setUnreadCount(response.data.length);
        } catch (error) {
            console.error('Failed to fetch notifications:', error);
        }
    };

    const toggleTheme = () => {
        document.documentElement.classList.toggle('dark');
        setIsDark(!isDark);
    };

    return (
        <header className="top-header" data-testid="header">
            <div className="flex items-center gap-4">
                <h2 className="text-xl font-bold uppercase tracking-wide" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                    {title}
                </h2>
            </div>
            
            <div className="flex items-center gap-3">
                <div className="relative hidden md:block">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                    <Input 
                        type="search" 
                        placeholder="Search..." 
                        className="pl-9 w-64 h-9 rounded-sm"
                        data-testid="header-search"
                    />
                </div>
                
                <Button 
                    variant="ghost" 
                    size="icon"
                    onClick={toggleTheme}
                    className="rounded-sm"
                    data-testid="theme-toggle"
                >
                    {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
                </Button>
                
                <Button 
                    variant="ghost" 
                    size="icon" 
                    className="relative rounded-sm"
                    onClick={() => navigate('/notifications')}
                    data-testid="notification-button"
                >
                    <Bell className="w-5 h-5" />
                    {unreadCount > 0 && (
                        <span className="absolute -top-1 -right-1 w-5 h-5 bg-primary text-primary-foreground text-xs rounded-full flex items-center justify-center font-semibold">
                            {unreadCount > 9 ? '9+' : unreadCount}
                        </span>
                    )}
                </Button>
            </div>
        </header>
    );
};
